import { createSelector } from '@reduxjs/toolkit';

import { UpcomingEventsState, type } from './state';
import { selectedIdSelector as customerSelectedIdSelector } from '../customers/selectors';

const featureStateSelector = (state: { [type]: UpcomingEventsState }) => state[type];

export const upcomingEventsSelector = createSelector(
    featureStateSelector,
    state => state.items
);

export const lastFetchedCustomerIdSelector = createSelector(
    featureStateSelector,
    state => state.lastFetchedCustomerId
);

export const scopedUpcomingEventsSelector = createSelector(
    upcomingEventsSelector,
    lastFetchedCustomerIdSelector,
    customerSelectedIdSelector,
    (items, lastFetchedCustomerId, selectedCustomerId) =>
        lastFetchedCustomerId != null && lastFetchedCustomerId === selectedCustomerId ? items : []
);

export const isFetchingUpcomingEventsSelector = createSelector(
    featureStateSelector,
    state => state.isFetching
);

export const errorMessageUpcomingEventsSelector = createSelector(
    featureStateSelector,
    state => state.errorMessage
);
